// Needs you: the notes waiting for the practitioner's signature (draft encounters), one list ranked by urgency.
// A visit from an earlier day is "overdue" (red: it asks for action); today's carry a neutral "today". A note never
// opened is new: a blue dot in the lead slot, the soft new-row tint, the title in body strong; the card's "N new"
// pill sits on the right. Opening an item (a modal, see needs-you-modal.tsx) makes it quiet. There is no data for the
// prototype's other kinds (eRx renewals, results, referrals, messages), for a due time ("before 09:15") or for snooze,
// so none of them is drawn.
import { HomeCard } from './home-card';
import type { NeedItem } from './ready-list-data';

export interface NeedsYouCardProps {
  items: readonly NeedItem[];
  /** Items opened at least once this session: quiet. The rest are new. */
  seen: ReadonlySet<string>;
  loading: boolean;
  error: boolean;
  onRetry: () => void;
  onOpen: (item: NeedItem) => void;
}

export function NeedsYouCard({ items, seen, loading, error, onRetry, onOpen }: NeedsYouCardProps) {
  const fresh = items.filter((n) => !seen.has(n.id)).length;
  const right = fresh > 0 ? <span data-needs-new className="home-pill">{fresh} new</span> : undefined;
  return (
    <HomeCard title="Needs you" right={right} flush data-testid="needs-you">
      {loading ? (
        <p className="home-empty home-empty-padded">Loading…</p>
      ) : error ? (
        <p className="home-empty home-empty-padded">
          Couldn&apos;t load your notes.{' '}
          <button type="button" className="home-link" onClick={onRetry}>
            Retry
          </button>
        </p>
      ) : items.length === 0 ? (
        <p className="home-empty home-empty-padded">Nothing needs you.</p>
      ) : (
        <ul className="need-list">
          {items.map((n) => {
            const isNew = !seen.has(n.id);
            return (
              <li key={n.id}>
                <button type="button" className="need-item" data-need={n.id} data-new={isNew ? '' : undefined} onClick={() => onOpen(n)}>
                  <span className="need-lead">{isNew && <span className="need-dot" data-new-dot role="img" aria-label="New" />}</span>
                  <span className="need-text">
                    <span className="need-title">{n.title}</span>
                    <span className="need-meta">{n.meta}</span>
                  </span>
                  <span className="need-due" data-tone={n.due.tone}>
                    {n.due.text}
                  </span>
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </HomeCard>
  );
}
